import TenantEnginePlugin from "./components/plugins/tenantengines/TenantEnginePlugin.vue";
import RdbDatastoreSelector from "./components/plugins/tenantengines/common/datastore/RdbDatastoreSelector.vue";
import TsDatastoreSelector from "./components/plugins/tenantengines/common/datastore/TsDatastoreSelector.vue";

import Postgres95Fields from "./components/plugins/tenantengines/common/datastore/postgres95/Postgres95Fields.vue";
import Warp10Fields from "./components/plugins/tenantengines/common/datastore/warp10/Warp10Fields.vue";
import InfluxDbFields from "./components/plugins/tenantengines/common/datastore/influxdb/InfluxDbFields.vue";
import NoFields from "./components/plugins/tenantengines/common/datastore/NoFields.vue";

import AssetManagementPlugin from "./components/plugins/tenantengines/assetmanagement/AssetManagementPlugin.vue";
import BatchOperationsPlugin from "./components/plugins/tenantengines/batchoperations/BatchOperationsPlugin.vue";
import CommandDeliveryPlugin from "./components/plugins/tenantengines/commanddelivery/CommandDeliveryPlugin.vue";
import DeviceManagementPlugin from "./components/plugins/tenantengines/devicemanagement/DeviceManagementPlugin.vue";
import DeviceRegistrationPlugin from "./components/plugins/tenantengines/deviceregistration/DeviceRegistrationPlugin.vue";
import DeviceStatePlugin from "./components/plugins/tenantengines/devicestate/DeviceStatePlugin.vue";
import EventManagementPlugin from "./components/plugins/tenantengines/eventmanagement/EventManagementPlugin.vue";
import EventSourcesPlugin from "./components/plugins/tenantengines/eventsources/EventSourcesPlugin.vue";
import InboundProcessingPlugin from "./components/plugins/tenantengines/inboundprocessing/InboundProcessingPlugin.vue";
import InstanceManagementPlugin from "./components/plugins/tenantengines/instancemanagement/InstanceManagementPlugin.vue";
import OutboundConnectorsPlugin from "./components/plugins/tenantengines/outboundconnectors/OutboundConnectorsPlugin.vue";
import ScheduleManagementPlugin from "./components/plugins/tenantengines/schedulemanagement/ScheduleManagementPlugin.vue";
import LabelGenerationPlugin from "./components/plugins/tenantengines/labelgeneration/LabelGenerationPlugin.vue";

/** Common */
export {
    TenantEnginePlugin,
    RdbDatastoreSelector,
    TsDatastoreSelector
}

/** Form elements */
export {
    Postgres95Fields,
    Warp10Fields,
    InfluxDbFields,
    NoFields
}

/** Plugins */
export {
    AssetManagementPlugin,
    BatchOperationsPlugin,
    CommandDeliveryPlugin,
    DeviceManagementPlugin,
    DeviceRegistrationPlugin,
    DeviceStatePlugin,
    EventManagementPlugin,
    EventSourcesPlugin,
    InboundProcessingPlugin,
    InstanceManagementPlugin,
    LabelGenerationPlugin,
    OutboundConnectorsPlugin,
    ScheduleManagementPlugin
}
